export const eventData = {
    eventState: false,
    eventCTA: 'Meet us',
    eventDescription: 'Asia Apparel Expo Berlin | 5-7 July | Booth 1C-47',
    eventURL: 'https://www.asiaapparelexpo.com/en-index.php',
}